const TOKEN_PATTERN = /\[\[([A-Za-z][A-Za-z0-9]*)\]\]/g
const UNRESOLVED_TOKEN_PATTERN = /\[\[[^\]]*\]\]/

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

export function renderAgreementTemplate(template: string, values: Readonly<Record<string, string>>): string {
  const rendered = template.replace(TOKEN_PATTERN, (_token, key: string) => {
    if (!Object.hasOwn(values, key)) {
      throw new Error(`Missing agreement template value for "${key}"`)
    }
    return escapeHtml(values[key])
  })

  if (UNRESOLVED_TOKEN_PATTERN.test(rendered)) {
    throw new Error("Unresolved agreement template token")
  }

  return rendered
}
